import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";

/**
 * Generated class for the WebfleetAddPositionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-add-position',
  templateUrl: 'webfleet-add-position.html',
})
export class WebfleetAddPositionPage {

  data: any = [];
  type: string = '';
  constructor(public teamappProvider: TeamappProvider, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams) {

  }

  ionViewDidEnter() {
    this.loadPositions();
  }

  loadPositions() {
    this.teamappProvider.http_request('action=get_book_positions', 'webfleet', false).then(data => {
      this.data = data;
      console.log('form datas');
      console.log(this.data);
    });
  }

  changePositionType() {
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetAddPositionPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/webfleet-add-position/webfleet-add-position.ts